import React from 'react';
import './HongInput.scss';

const HongInput = ({ 
  value, 
  onChange, 
  className, 
  placeholder, 
  isNumber = false, 
  spellCheck = false, 
  autoComplete = 'off',
  readOnly = false // ✅ 추가
}) => {

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    if (readOnly) return; // ✅ 읽기 전용이면 변경 무시

    if (isNumber) { 
      if (/^\d*$/.test(inputValue)) {
        onChange(e);
      }
    } else {
      onChange(e);
    }
  };

  return (
    <input
      type="text"
      className={`hong-input ${className}`}
      value={value}
      onChange={handleInputChange}
      placeholder={placeholder}
      spellCheck={spellCheck}
      autoComplete={autoComplete}
      readOnly={readOnly} // ✅ 적용
    />
  );
};

export default HongInput;
